import { ApolloError } from '@apollo/client';

import notificationService from 'services/notificationService';

import { TGetPostPaymentsItem } from './interfaces';

export const getPostPaymentsItem: TGetPostPaymentsItem = ({
  t,
  isPostPaymentsAvailable,
  permissions,
  startClientSession,
  selectedHostsIds,
}) => {
  return !permissions?.has('payment_create')
    ? null
    : {
        key: 'post_payment',
        text: t('setting.post_payment'),
        iconName: 'TimeForwardIcon',
        onClick: (host) =>
          startClientSession({
            variables: {
              input: {
                host_id: host.id,
                post_paid: true,
              },
            },
          }).catch((error: ApolloError) => {
            return notificationService.info({
              dismiss: 3,
              t,
              type: 'error',
              title: t('post_payment.error.title'),
              message: error?.message,
              leftDescription: host.alias,
            });
          }),
        disabled: ({ client_sessions, user }) =>
          client_sessions.length > 0 ||
          !isPostPaymentsAvailable ||
          !!user?.uuid ||
          !!(selectedHostsIds && selectedHostsIds.length > 1),
      };
};
